module.exports = __webpack_public_path__ + "static/media/16-above-scan-2.04714a00.png";